export default __webpack_public_path__ + "static/sa-flag-bba81f588f75291e0091db58c09e6075.svg";